import Icon from '@components/common/assets';
import { ProfileInfoType } from '@components/match/profile/types';
import Colors from '@domain/constant/colors';

import classnames from 'classnames/bind';
import styles from './jobselectNeeded.module.scss';
const cx = classnames.bind(styles);

interface IJobSelectNeededProps {
  profileInfoType: ProfileInfoType;
  onClick: () => void;
}

const JobSelectNeeded = ({ profileInfoType, onClick }: IJobSelectNeededProps) => {
  const text = profileInfoType === 'GENERAL' ? '직무' : '개발 직무';
  return (
    <a role="button" className={cx('container')} onClick={onClick}>
      <div className={cx('add')}>
        <Icon name="addLight" width={24} height={24} fill={Colors.C_WHITE} />
      </div>
      <div className={cx('text')}>
        <span className={cx('gray')}>제안 받고 싶은</span>
        <br />
        {text}를 선택해보세요.
      </div>
    </a>
  );
};

export default JobSelectNeeded;
